(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .service("cacheService", cacheService);

  cacheService.$inject = ["$window", "$cacheFactory"];

  //Handles saving and loading things from local/session storage for persistance and performance.
  function cacheService($window, $cacheFactory) {

    var routePointsCache = $cacheFactory("routePointsCache", {
      number: 100   //Max 100 route point arrays
    });

    var defaultCacheObj = {
      vehicleGroupFilter: "",
      driverGroupFilter: "",
      selectedGroupType: "vehicleGroup",
      complianceReportFilters: {
        vehicleName: "",
        routeSource: "",
        routeProfile: ""
      },
      gridSortType: "",
      gridSortReverse: false,
    };

    //A generic cache object that can be used by the whole app. Saved to session storage
    var cacheObj = angular.copy(defaultCacheObj);

    //Holds a key-value mapping of page numbers to route lists for the current search settings.
    var cachedRoutesObj = null;

    var cacheStr = $window.sessionStorage["appCacheObj"];
    if (cacheStr) {
      cacheObj = JSON.parse(cacheStr);
    }

    const service = {
      //Get a generic cache object that persists in session storage. (Persists in session storage across page refreshes but not across tabs)
      //Can be get/set with cacheService.getCache().<prop> = <val>, and saved with cacheService.saveCache()
      //Do not put things too large in here, max browser sessionStorage size is 5 MB
      getCache: getCache,
      //Save the cache object to session storage
      saveCache: saveCache,

      //Get/set the vm.settings variable that is used by a lot of the pages (parameters for fetching compliance data). Persists in session storage.
      setSearchSettings: setSearchSettings,
      getSearchSettings: getSearchSettings,

      //Get/set cached route points (only persists in-memory, lost on refresh)
      getCachedRoutePoints: getCachedRoutePoints,
      setCachedRoutePoints: setCachedRoutePoints,

      //Get/Set/clear compliance route response cache, keyed by page number. (only persists in-memory, lost on refresh)
      getCachedRouteResponse: getCachedRouteResponse,
      setCachedRouteResponse: setCachedRouteResponse,
      clearCachedRouteResponses: clearCachedRouteResponses,

      clearForLogout: clearForLogout
    };

    function getCache() {
      return cacheObj;
    }

    function saveCache() {
      var cacheObjStr = JSON.stringify(cacheObj);
      $window.sessionStorage["appCacheObj"] = cacheObjStr;
    }

    /**
     * @param {object} settings
     */
    function setSearchSettings(settings) {
      if(_.isEmpty(settings)) {
        //console.error("Can't input an empty settings!");
        return;
      }
      //console.log("Setting search settings " + settings);
      cachedRoutesObj = null;   //When the search settings change, the cached route list should be cleared.
      $window.sessionStorage["complianceSearchSettings"] = JSON.stringify(settings);
    }

    /**
     * @returns {object} The search settings object or null if not found
     */
    function getSearchSettings() {
      var searchSettings = $window.sessionStorage["complianceSearchSettings"];
      if (searchSettings) {
        //console.log("Getting search settings " + JSON.parse(searchSettings));
        return JSON.parse(searchSettings);
      }
      return null;
    }

    /**
     *
     * @param {string} tripId
     * @param {object} routingProfile
     * @returns {array} The cached route points array
     */
    function getCachedRoutePoints(tripId, routingProfile) {
      var rpId = routingProfile && routingProfile.routingProfileId ? routingProfile.routingProfileId : "";
      var cacheKey = String(tripId) + String(rpId);
      var cacheResult = routePointsCache.get(cacheKey);
      if (cacheResult) {
        //console.log("Retrieved cached points from trip " + tripId + " + rp id " + rpId);
        //console.log(cacheResult);
      }
      return cacheResult;
    }

    /**
     *
     * @param {string} tripId
     * @param {string} routingProfile
     * @param {array} routeMercPoints
     */
    function setCachedRoutePoints(tripId, routingProfile, routeMercPoints) {
      var rpId = routingProfile && routingProfile.routingProfileId ? routingProfile.routingProfileId : "";
      if (!tripId && !rpId) {
        console.error("Can't put empty fields in route points cache");
      }
      var cacheKey = String(tripId) + String(rpId);
      //console.log("Putting cached points for trip " + tripId + " + rp id " + rpId);
      //console.log(routeMercPoints);
      routePointsCache.put(cacheKey, routeMercPoints);
    }

    //On logout or account switch, need to clear account-specific cache data
    function clearForLogout() {
      $window.sessionStorage["complianceSearchSettings"] = "";
      cacheObj = angular.copy(defaultCacheObj);
      $window.sessionStorage["appCacheObj"] = "";
      $cacheFactory.get("$http").removeAll();
      clearCachedRouteResponse();
    }

    //Set a key-value mapping entry
    function setCachedRouteResponse(currentPageNum, routeResponse) {
      if (!cachedRoutesObj) {
        cachedRoutesObj = {};
      }
      cachedRoutesObj[currentPageNum] = routeResponse;
    }

    //Given a page number and the index in that page number, get the route response if exists, or null otherwise.
    function getCachedRouteResponse(currentPageNum) {
      if(!cachedRoutesObj) {
        cachedRoutesObj = {};
      }
      var currentPage = cachedRoutesObj[currentPageNum];
      if(currentPage) {
        return currentPage;
      }
      return null;
    }

    function clearCachedRouteResponses() {
      cachedRoutesObj = null;
    }

    return service;

  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/components/cache.service.js